import React, { useState  , useEffect , useRef} from 'react';
import * as rulesService from "../services/rulesService";
import Swal from 'sweetalert2';
import { Dialog } from 'primereact/dialog';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
export function AdminAddEditRules() {
    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [rules, setRules] = useState([{ id: '', title: '', link: '' , ind: '' }]);
    const [textField, setTextField] = useState(null);
    const [visible, setVisible] = useState(false);
    const [currentId, setCurrentId] = useState(false);
    const [editTextField, setEditTextField] = useState(null);

    document.title = `Всички наредби`;

    const reorderTimer = useRef(null);

    const handleFileChange = (event) => {

        const file = event.target.files[0];
      
        if (file && file.name.endsWith('.pdf')) {
            setFile(file);
        } else {
            // Alert the user if the file is not a PDF
            Swal.fire({ title: "Внимание", text: 'Може да прилагате само pdf файлове!', icon: "error" });
            event.target.value = '';
        }
    }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        /*console.log('rules->');
        console.log(rules);*/

        const reordered = Array.from(rules);
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);

        const updated = reordered.map((r, i) => ({ ...r, ind: i + 1 }));
        setRules(updated);

        
        if (reorderTimer.current) {
            clearTimeout(reorderTimer.current);
        }

        const payload = updated.map(({ id, ind, title, link }) => ({ id, ind, title, link }));

        reorderTimer.current = setTimeout(async () => {

            try {
                

                const res = await rulesService.OrderRules(payload);

              
                if (res && Array.isArray(res)) {
                    setRules(prev =>
                        prev.map(item => {
                            const updatedItem = res.find(r => r.id === item.id);
                            return updatedItem ? { ...item, ind: updatedItem.ind } : item;
                        })
                    );
                }


            } catch (error) {
                Swal.fire({
                    title: error,
                    text: error.message,
                    icon: "error"
                });
            }
            
        }, 5);
    };

    const handleTextFieldChange = (event) => {
        setTextField(event.target.value);
    }

    const handleFileUpload = async (e) => {
        e.preventDefault();


        const numberOfRules = rules.length;
        

        if (!file) { Swal.fire({ title: "Внимание", text: 'Моля изберете файл!', icon: "error" }); return; }
        if (!textField ) { Swal.fire({ title: "Внимание", text: 'Моля въведете име на наредба!', icon: "error" }); return; }

        try {

            const formData = new FormData();
            formData.append('Title', textField);
            formData.append('PdfFile', file);
            formData.append('Ind', numberOfRules + 1);


            console.log('ent');
            console.log(formData);

            const res = await rulesService.create(formData);

            if (res != null) {
                const newRule = {
                    id: 0, // Assuming the number represents the ID
                    title: textField,
                    link: file,
                    Id: numberOfRules + 1
                };

                //console.log(newRule);
                setFile(null);
                setTextField('');
                document.getElementById('title').value = '';
                document.getElementById('idfile').value = '';

                setRules(prevRules => [...prevRules, newRule]);
                Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
            }


            

            
        } catch (error) {
            Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
        }


    }

    const handleFileDelete = async (id) => {

        const result = await Swal.fire({
            title: 'Сигурни ли сте?',
            text: 'Желаете ли да изтриете тази наредба?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Отказ',
            confirmButtonText: 'Да, изтриване!'
        });

        if (result.isConfirmed) {
            try {
                const res = await rulesService.del(id);
                const updatedRules = rules.filter(rule => rule.id !== id);
                setRules(updatedRules);
                Swal.fire({ title: "Успешно изтриване!", text: "", icon: "success" });
            } catch (error) {
                Swal.fire({ title: "Грешка при изтриване!", text: error.message, icon: "error" });
            }
        }
    }

    const handleEditTitle = (id, title) => {
        setCurrentId(id);
        setEditTextField(title);
        setVisible('visible');
    }

    const saveTitle = async () => {
        setVisible('visible');

        try {
            rulesService.edit(currentId, editTextField)
                .then((res) => {
                    setVisible(false);
                    console.log(res);
                    setRules(prev => {
                        const updated = prev.map(item =>
                            item.id == res.id ? { ...item, title: res.title } : item
                        );
                        console.log("updated rules:", updated);
                        return updated;
                    });

                })      

        } catch (error) {
            Swal.fire({ title: "Грешка при опит за редакция!", text: error.message, icon: "error" });
        }
        
    }

    useEffect(() => {

        const populateRules = async () => {
            try {
                rulesService.getAll()
                    .then((res) => {
                        setRules(res[0]);
                })
            } catch (error) {
                Swal.fire({ title: "Грешка при четене на правилата!", text: error.message, icon: "error" });
            }
        }
        populateRules();

    }, []);





    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Добави / редактирай наредби</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Редактирай наредби</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">

                            <div className="overflow-auto card recent-sales p-5 p-3-mob">
                                <h5 className="card-title"><span>Добави наредба (задължително pdf file)</span></h5>

                                <form >
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="title">Име на наредба</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <input type="text" id="title" className="w-100-mob mb-2-mob" name="title" onChange={handleTextFieldChange} />
                                            <input type="file" id='idfile' className="w-100-mob m-0-mob" onChange={handleFileChange} style={{ marginLeft: 10}} />
                                            <button className="btn btn-primary mt-2 mb-2 w-16 w-35-mob" onClick={handleFileUpload}>Добави</button>
                                        </div>
                                    </div>
                                    {uploadStatus && <p>{uploadStatus}</p>}
                                </form>

                                <Dialog
                                    header="Редакция на наименование"
                                    visible={visible}
                                    onHide={() => setVisible(false)}
                                    className="w-300-mob"
                                    style={{ width: '50vw' }}
                                >
                                    <div className="mb-3 w-100" style={{ maxWidth: '800px' }}>
                                        <label htmlFor="title" className="form-label">Заглавие</label>
                                        <input
                                            type="text"
                                            id="title"
                                            className="form-control"
                                            style={{ width: '100%', maxWidth: '900px' }}
                                            value={editTextField}
                                            onChange={(e) => setEditTextField(e.target.value)}
                                        />
                                    </div>

                                    <div className="mt-3">
                                        <button className="btn btn-primary mt-2 mb-2 w-16 w-35-mob" onClick={saveTitle}>Запази</button>
                                    </div>
                                </Dialog>

                            </div>

                        </div>
                    </div>

                </div>

                <div className="row ">

                    {(!rules) ? (<p>...</p>) : (
                        <>
                            <table className="table table-striped table-hover w-100 w-100-mob">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Наименование на наредба</th>
                                        <th className="text-center" scope="col"></th>
                                        <th className="text-center" scope="col"></th>
                                    </tr>
                                </thead>
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    <Droppable droppableId="rules">
                                        {(provided) => (
                                            <tbody
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{ cursor: "grab" }}
                                            >
                                                {rules.map((r, index) => (
                                                    <Draggable
                                                        key={r.id.toString()}
                                                        draggableId={r.id.toString()}
                                                        index={index}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <tr
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    backgroundColor: snapshot.isDragging
                                                                        ? "#f0f8ff"
                                                                        : "",
                                                                    transition: "background-color 0.2s ease",
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                <td>{index + 1}</td>
                                                                <td>{r.title}</td>
                                                                <td className="text-center">
                                                                    <i
                                                                        className="bi bi-pencil-square edit_but"
                                                                        onClick={() =>
                                                                            handleEditTitle(r.id, r.title)
                                                                        }
                                                                    ></i>
                                                                </td>
                                                                <td className="text-center">
                                                                    <i
                                                                        className="bi bi-x-square del_but"
                                                                        onClick={() => handleFileDelete(r.id)}
                                                                    ></i>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </tbody>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                {/*<tbody>*/}
                                {/*    {rules.map((r, index) => (*/}
                                {/*        <tr key={index+1}>*/}
                                {/*            <td>{index + 1}</td>*/}
                                {/*            <td>{r.title}</td>*/}
                                {/*            <td className="text-center">*/}
                                {/*                <i className="bi bi-pencil-square edit_but" onClick={() => { handleEditTitle(r.id, r.title) }}></i>*/}
                                {/*            </td>*/}
                                {/*            <td className="text-center">*/}
                                {/*                <i className="bi bi-x-square del_but" onClick={() => { handleFileDelete(r.id) }}></i>*/}
                                {/*            </td>*/}
                                {/*        </tr>*/}
                                {/*    ))}*/}
                                {/*</tbody>*/}
                            </table>
                        </>
                    )}
                </div>

            </section>

        </main>
    )
}

export default AdminAddEditRules;

